import { Injectable, inject } from "@angular/core";
import { AppConstants } from "@core/constants";
import { ManageOrganizationDto } from "@core/services/manage-organizations/manage-organization-dto";
import { ManageOrganizationsService } from "@core/services/manage-organizations/manage-organizations.service";
import { SessionService } from "@core/services/session.service";
import { createNullableState } from "@shared/helpers/create-state.helper";
import { withSpinner } from "@shared/operators/with-spinner.operator";
import { CustomRendererService } from "@shared/services/custom-renderer.service";
import { Observable } from "rxjs";

@Injectable()
export class AdditionalInfoStore {
  private readonly customRendererService = inject(CustomRendererService);
  private readonly organizationService = inject(ManageOrganizationsService);
  private readonly sessionService = inject(SessionService);

  organization = createNullableState<ManageOrganizationDto>();

  loadStore(): void {
    const organizationId = this.getAuth()?.organization?.id;
    if (!organizationId) {
      return;
    }

    this.fetchOrganization(organizationId)
      .pipe(withSpinner(this.customRendererService, AppConstants.MAT_SPINNER_CLASS))
      .subscribe({
        next: (response) => {
          this.organization.set(response);
        },
        error: (e) => {
          console.log(e);
        },
      });
  }

  getAuth(): Record<string, any> {
    return JSON.parse(this.sessionService.getCookie("auth") || "{}");
  }

  private fetchOrganization(organizationId: number): Observable<ManageOrganizationDto> {
    return this.organizationService.getOrganizationById(organizationId);
  }
}
